import React from 'react';
import { ProbabilityForecastWidgetConfig } from './types';

interface ProbabilityForecastWidgetBuilderProps {
  config: Partial<ProbabilityForecastWidgetConfig>;
  onChange: (config: ProbabilityForecastWidgetConfig) => void;
}

const ProbabilityForecastWidgetBuilder: React.FC<ProbabilityForecastWidgetBuilderProps> = ({
  config,
  onChange,
}) => {
  const resolutionWindow = config.resolutionWindow ?? 1;

  return (
    <div className="space-y-4">
      <div className="bg-warning-50 border border-warning-200 rounded-lg p-4 text-sm text-warning-800">
        <strong>Price-Move Forecast Widget</strong>
        <p className="mt-1">
          Captures the analyst&apos;s probability that the stock rises after the print.
          After the event resolves, it is Brier-scored against the realized move.
        </p>
      </div>

      <div className="border rounded-lg p-4 bg-surface">
        <label className="block text-sm font-medium text-neutral-700 mb-1">
          Resolution window (trading days)
        </label>
        <input
          type="number"
          min={1}
          max={20}
          value={resolutionWindow}
          onChange={(e) =>
            onChange({ ...config, resolutionWindow: Math.max(1, Number(e.target.value) || 1) })
          }
          className="w-24 border rounded px-2 py-1 text-sm"
        />
        <p className="mt-2 text-xs text-neutral-500">
          How many trading days after the print the move is measured at scoring time.
          The reaction day (1) is the default.
        </p>
      </div>
    </div>
  );
};

export default ProbabilityForecastWidgetBuilder;
